import request from '../../services/request.service';
import { applianceSN } from '../../config';

export const GET_APPLIANCE_SERIAL_NUMBERS = 'GET_APPLIANCE_SERIAL_NUMBERS';
export const GET_APPLIANCE_SERIAL_NUMBERS_SUCCESS = 'GET_APPLIANCE_SERIAL_NUMBERS_SUCCESS';
export const GET_APPLIANCE_SERIAL_NUMBERS_FAIL = 'GET_APPLIANCE_SERIAL_NUMBERS_FAIL';

export const DELETE_APPLIANCE_SERIAL_NUMBER = 'DELETE_APPLIANCE_SERIAL_NUMBER';
export const DELETE_APPLIANCE_SERIAL_NUMBER_SUCCESS = 'DELETE_APPLIANCE_SERIAL_NUMBER_SUCCESS';
export const DELETE_APPLIANCE_SERIAL_NUMBER_FAIL = 'DELETE_APPLIANCE_SERIAL_NUMBER_FAIL';

export const CREATE_APPLIANCE_SERIAL_NUMBER = 'CREATE_APPLIANCE_SERIAL_NUMBER';
export const CREATE_APPLIANCE_SERIAL_NUMBER_SUCCESS = 'CREATE_APPLIANCE_SERIAL_NUMBER_SUCCESS';
export const CREATE_APPLIANCE_SERIAL_NUMBER_FAIL = 'CREATE_APPLIANCE_SERIAL_NUMBER_FAIL';

export const UPDATE_APPLIANCE_SERIAL_NUMBER = 'UPDATE_APPLIANCE_SERIAL_NUMBER';
export const UPDATE_APPLIANCE_SERIAL_NUMBER_SUCCESS = 'UPDATE_APPLIANCE_SERIAL_NUMBER_SUCCESS';
export const UPDATE_APPLIANCE_SERIAL_NUMBER_FAIL = 'UPDATE_APPLIANCE_SERIAL_NUMBER_FAIL';

export function getApplianceSerialNumbers(params) {
  return async dispatch => {
    dispatch({
      type: GET_APPLIANCE_SERIAL_NUMBERS,
    });

    try {
      const url = `${applianceSN.appliancesSN}?filter=${window.encodeURIComponent(JSON.stringify(params))}`;
      const response = await request(url, { method: 'GET' });

      dispatch({
        type: GET_APPLIANCE_SERIAL_NUMBERS_SUCCESS,
        recordsData: response.body,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: GET_APPLIANCE_SERIAL_NUMBERS_FAIL,
      });
    }
  };
}

export function updateApplianceSerialNumber(data) {
  return async dispatch => {
    dispatch({
      type: UPDATE_APPLIANCE_SERIAL_NUMBER,
    });

    try {
      await request(applianceSN.updateApplianceSN, { method: 'POST', body: data });

      dispatch({
        type: UPDATE_APPLIANCE_SERIAL_NUMBER_SUCCESS,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: UPDATE_APPLIANCE_SERIAL_NUMBER_FAIL,
      });
      throw err;
    }
  };
}

export function createApplianceSerialNumber(data) {
  return async dispatch => {
    dispatch({
      type: CREATE_APPLIANCE_SERIAL_NUMBER,
    });

    try {
      await request(applianceSN.addApplianceSN, { method: 'POST', body: data });

      dispatch({
        type: CREATE_APPLIANCE_SERIAL_NUMBER_SUCCESS,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: CREATE_APPLIANCE_SERIAL_NUMBER_FAIL,
      });
      throw err;
    }
  };
}

export function deleteApplianceSerialNumber(applianceId) {
  return async dispatch => {
    dispatch({
      type: DELETE_APPLIANCE_SERIAL_NUMBER,
    });

    try {
      await request(applianceSN.applianceSN(applianceId), { method: 'DELETE' });

      dispatch({
        type: DELETE_APPLIANCE_SERIAL_NUMBER_SUCCESS,
      });
    } catch (err) {
      console.log(err);
      dispatch({
        type: DELETE_APPLIANCE_SERIAL_NUMBER_FAIL,
      });
    }
  };
}
